module.exports = __webpack_public_path__ + "img/admin-capture-product.0019a6e9.png";